import { Maybe } from 'src/types';
import { IOfferContainerProps, ITableLinkProps } from './types';
import { trackProductPriceClickRevenue } from './tracking';

export function logRevenueEvent(id: string, productId: number) {
  try {
    // Fetch price for the click out and log it as a Revenue event
    // to Amplitude
    fetch(`/_internal/click-out-pricing/${id}`)
      .then(res => res.json())
      .then(clickPrice => {
        if (clickPrice) {
          trackProductPriceClickRevenue({
            id: productId,
            price: clickPrice,
          });
        }
      });
  } catch (err) {} // eslint-disable-line no-empty
}

export const setAntiBotFlag = (
  e:
    | React.MouseEvent<HTMLAnchorElement>
    | React.KeyboardEvent<HTMLAnchorElement>
    | React.TouchEvent<HTMLAnchorElement>
) => {
  if (!IS_BROWSER) return;

  const oldHref = e.currentTarget.href;
  const newHref = oldHref.includes('&bc=1') ? oldHref : `${oldHref}&bc=1`;

  e.currentTarget.href = newHref;
};

const baseLinkProps = {
  rel: 'nofollow noopener',
  onMouseDown: setAntiBotFlag,
  onTouchStart: setAntiBotFlag,
  onKeyDown: setAntiBotFlag,
  target: '_blank',
};

export const getTableLinkProps = (
  featured: boolean,
  onClick: (e: React.MouseEvent<Element, MouseEvent>) => void,
  externalUri: Maybe<string> | undefined
): ITableLinkProps => {
  return {
    ...baseLinkProps,
    href: externalUri || undefined,
    onClick,
    target: '_blank',
    disabled: !externalUri,
    featured,
  };
};

export const getContainerProps = (
  name: string,
  featured: boolean,
  onClick: (e: React.MouseEvent<Element, MouseEvent>) => void,
  externalUri: Maybe<string> | undefined
): IOfferContainerProps => {
  return {
    ...baseLinkProps,
    to: externalUri || undefined,
    'aria-label': name,
    isExternal: true,
    disabled: !externalUri,
    onClick,
    featured,
  };
};
